<div class="dialog-agent">
  <div mat-dialog-content class="pb-0">
    <div>
      <div class="w-100 d-inline-block pt-2 pb-3">
        <b class="h4 px-2">
          <span *ngIf="data.type === 'SetPin'">
            {{ 'GLOBAL.SET-USER-PIN' | translate }}
          </span>
          <span *ngIf="data.type === 'RecoverPin'">
            {{ 'GLOBAL.RESET-USER-PIN' | translate }}
          </span>
        </b>
      </div>
    </div>

    <div class="w-100 d-inline-block">
      <p class="p-3 m-0 bg-light text-dark border-radius-20px">
        <span class="d-inline-block w-100 pb-3">
          {{ 'GLOBAL.USER-PIN-ALERT' | translate }}
        </span>
        <b *ngIf="data.type === 'SetPin'">
          {{ 'GLOBAL.SET-USER-PIN-ALERT' | translate }}
        </b>
        <b *ngIf="data.type === 'RecoverPin'">
          {{ 'GLOBAL.RESET-USER-PIN-ALERT' | translate }}
        </b>
      </p>
    </div>
  </div>

  <div mat-dialog-actions class="w-100">
    <button mat-raised-button color="primary" class="ms-2 float-end" [mat-dialog-close]="true">
      <i class="rt-icon rt-comprobado-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CONTINUE' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" [mat-dialog-close]="false">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.CANCEL' | translate }}</span>
    </button>
  </div>
</div>
